import React, {Component} from 'react';
import pubSUb from '../../PubSub';

const SOCIAL_MESSAGE_MAX_LENGTH = 230;
const socialShareButtonSettings = {
    'FACEBOOK': {
        btnBackgroundColor: '#475993',
        logoSrc: '/images/social/facebook_3.png'
    },
    'TWITTER': {
        btnBackgroundColor: '#03A9F4',
        logoSrc: '/images/social/twitter_3.png'
    },
    'LINKEDIN': {
        btnBackgroundColor: '#0077B7',
        logoSrc: '/images/social/linkedin_3.png'
    }
};
class SocialShareView extends Component {
    state = {
        message: this.props.communitySettings && this.props.communitySettings.message,
        socialMessageCounter: SOCIAL_MESSAGE_MAX_LENGTH,
        hidden: false
    };

    openShareWindow=(socialNetwork) => () => {
        const {eventUrl} = this.props;
        const socialMessage = this.state.message;
        const popupConfig = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600';
        switch (socialNetwork) {
        case 'FACEBOOK':
            window.open(`http://www.facebook.com/sharer/sharer.php?u=${eventUrl}`, '', popupConfig);
            pubSUb.publish('analytics:ShareDone', {facebook: true});
            break;
        case 'TWITTER':
            window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(socialMessage)}`, '', popupConfig);
            pubSUb.publish('analytics:ShareDone', {twitter: true});
            break;
        case 'LINKEDIN':
            window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${eventUrl}&title=${encodeURIComponent(socialMessage)}&source=Bizzabo`, '', popupConfig);
            pubSUb.publish('analytics:ShareDone', {linkedin: true});
        }
    };

    hide = () => {
        this.setState({ hidden: true });
        const { onHide } = this.props;
        onHide();
    };

    onChangeHandler = (elem) => {
        const socialMessageCounter = SOCIAL_MESSAGE_MAX_LENGTH - elem.target.value.length;
        const message = elem.target.value;

        this.setState({message, socialMessageCounter});
    };

    render() {
        const {communitySettings: {socialNetworks}, profileImg} = this.props;
        const enabledSocialNetworks = socialNetworks.filter(( socialNetwork ) => socialNetwork.enabled);
        const socialButtonSmColumn = enabledSocialNetworks.length && 12 / enabledSocialNetworks.length || 4;
        const {message, hidden, socialMessageCounter} = this.state;
        return <div className={`auth-view ${hidden ? 'hide' : ''}`}>
            <div className="auth-view-box">
                <div className="sign-up-view font-titillium">
                    <div className="text-center">
                        <h1 className="bz-header color-1 margin-bottom-medium">Share Your Plans!</h1>
                    </div>
                    <div className="sign-up-view-content">
                        <div className="sign-up-view-content">
                            <div className="social-share-profile-img-container">
                                <img name="photoUrl"
                                    src={profileImg || '/images/community/profile_with_shadow.png'}
                                    className="social-share-profile-img color-1"
                                />
                            </div>
                            <div className="social-share-message-v2">
                                <textarea className="bz-input form-control social-share-message-textarea" name="message" maxLength={230}
                                    placeholder="Share Message"
                                    value={message}
                                    onChange={this.onChangeHandler}>
                                </textarea>
                                <div className="new-social-share-message-counter"> {socialMessageCounter} </div>
                            </div>
                        </div>
                        <div className="sign-up-view-content row">
                            <div className="social-share-networks text-center margin-top-xs">
                                {enabledSocialNetworks.map(({socialNetwork}, i) =>
                                    <div key={socialNetwork} className={`col-sm-${socialButtonSmColumn} col-xs-12 social-share-network-container btn`} onClick={this.openShareWindow(socialNetwork)}>
                                        <div className="social-share-network-btn" style={{background: socialShareButtonSettings[socialNetwork].btnBackgroundColor}}>
                                            <div className="social-share-network-img-container"><img className="social-share-network-img" src={socialShareButtonSettings[socialNetwork].logoSrc}/></div>
                                            <div className="social-share-network-btn-text" >{`SHARE ON ${socialNetwork}`}</div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className={'continue-to-community-wrapper text-center padding-medium'}>
                            <a className={'continue-to-community-text color-1'} onClick={this.hide} >Continue to Community</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

export default SocialShareView;


